import React, { type FC } from 'react';
import { connect } from 'react-redux';
import { LocationHeader } from '../../components/LocationHeader';
import Styles from './styles.scss';

interface OwnProps {
	inSemanticSearch?: boolean;
	semanticSearchString?: string;
}

type StateProps = ReturnType<typeof mapStateToProps>;
type TitleProps = OwnProps & StateProps;

const Title: FC<TitleProps> = (props) => {
	const {
		inSemanticSearch,
		semanticSearchString,
		totalVendors,
		categoryPlural,
		categorySingular,
		seoFilter,
	} = props;
	const categoryTerm = totalVendors === 1 ? categorySingular : categoryPlural;
	const baseHeaderText =
		!seoFilter || seoFilter === '' ? categoryTerm : seoFilter;

	return (
		<div
			className={
				inSemanticSearch ? Styles.semanticSearchHeader : Styles.searchHeader
			}
		>
			<LocationHeader
				totalVendors={totalVendors}
				headerText={baseHeaderText}
				semanticSearchString={semanticSearchString}
			/>
		</div>
	);
};

const mapStateToProps = (state: Redux.State) => ({
	categoryPlural: state.category.plural.term,
	categorySingular: state.category.singular.term,
	seoFilter: state.seo.seoFilter,
	totalVendors: state.search.total,
});

export default connect(mapStateToProps)(Title);
